<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">{{ $translate("shops") | capitalize }}</h1>
      <table-actions
        v-bind:canCreate="permissions.canCreate"
        v-bind:canHide="permissions.canHide"
        v-bind:canDelete="permissions.canDelete"
        v-bind:multipleSelectionIcon="multipleSelectionIcon"
        v-bind:formLink="{
          name: 'newShop',
        }"
        :checkedRows.sync="tableOptions.checkedRows"
        v-on:viewhiddenchange="switchViewHidden"
        v-on:search="searchData"
        v-on:changesearchQuery="changesearchQuery"
        v-on:hideItems="multipleHiding('shops')"
        v-on:deleteItems="multipleDelete('shops')"
        v-bind:disabled.sync="tableOptions.loading"
      />
      <div class="level-left second-level" v-if="userInfo.type != 'C'">
        <div class="level-item">
          <p class="is-size-5 has-text-primary">
            {{ $translate("filter") | capitalize }}
          </p>
        </div>
        <div class="level-item">
          <filter-select
            v-if="userInfo.type == 'C'"
            v-model="companiesFilterInfo"
            v-on:change="searchData()"
          />
        </div>
        <div class="level-item">
          <filter-select
            v-model="countriesFilterInfo"
            v-on:change="searchData()"
          />
        </div>
      </div>
      <b-table
        :sticky-header="true"
        :data="tableData"
        :narrowed="true"
        :checked-rows.sync="tableOptions.checkedRows"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        :backend-sorting="true"
        checkable
        detailed
        @sort="sortPressed"
        @check="multipleSelectionIconManage"
        hoverable
        :row-class="(row, index) => !row.isActive && 'hiding-row'"
      >
        <template slot-scope="props">
          <b-table-column
            field="mercurio_id"
            :label="$translate('id_mercury') | capitalize"
            sortable
            >{{ props.row.mercurio_id }}</b-table-column
          >
          <b-table-column
            field="companyId"
            :label="$translate('company') | capitalize"
            :sortable="
              userInfo.type != 'C' && $route.params.companyId == undefined
            "
          >
            <a
              v-if="props.row.company != undefined"
              @click="
                $router.push({
                  name: 'companies',
                  params: { companyId: props.row.companyId },
                })
              "
              >{{ props.row.company.name }}</a
            >
          </b-table-column>
          <b-table-column
            field="name"
            :label="$translate('name') | capitalize"
            sortable
            >{{ props.row.name }}</b-table-column
          >
          <b-table-column
            field="address.city"
            :label="$translate('city') | capitalize"
            sortable
            >{{ props.row.address["city"] }}</b-table-column
          >
          <b-table-column
            field="country"
            :label="$translate('country') | capitalize"
            >{{ $translate(props.row.address["country"]) }}</b-table-column
          >
          <b-table-column
            field="email"
            :label="$translate('mail') | capitalize"
          >
            <a :href="'mailto:' + props.row.email">{{ props.row.email }}</a>
          </b-table-column>
          <b-table-column :label="$translate('action') | capitalize">
            <a
              v-if="permissions.canEdit"
              @click="
                $router.push({
                  name: 'editShop',
                  params: { id: props.row.id },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <a
              v-if="permissions.canDelete"
              @click="deleteItemModal(props.row, 'shops')"
            >
              <b-icon icon="delete-outline"></b-icon>
            </a>
            <a
              @click="
                $router.push({
                  name: 'patients',
                  params: { shopId: props.row.id },
                })
              "
            >
              <b-icon icon="format-list-checkbox"></b-icon>
            </a>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $translate("tel") | capitalize }}</strong>
                  {{ props.row.phone }}
                  <br />
                  <strong>{{ $translate("address") | capitalize }}</strong>
                  {{ printAddress(props.row.address) }}
                </p>
                <strong>{{ $translate("shipping_bool") | capitalize }}</strong>
                <b-icon v-if="props.row.useForShipping" icon="check"></b-icon>
                <b-icon v-if="!props.row.useForShipping" icon="close"></b-icon>
              </div>
            </div>
          </article>
        </template>
        <template slot="footer" v-if="!disableRequestMore">
          <b-button @click="appendData()" expanded>
            <b-icon icon="arrow-down-thick"></b-icon>
          </b-button>
        </template>
        <template slot="empty">
          <section class="section" v-if="!tableOptions.loading">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
            </div>
          </section>
        </template>
      </b-table>
      <!--<br /><br />
      <div class="level" v-if="userInfo.type != 'C'">
        <div class="level-left">
          <div class="level-item">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">{{ $translate("filter") | capitalize }}</p>
              </header>
              <div class="card-content">
                <filter-select
                  v-if="userInfo.type == 'C'"
                  v-model="companiesFilterInfo"
                  v-on:change="searchData()"
                />
                <filter-select
                  v-model="countriesFilterInfo"
                  v-on:change="searchData()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </section>
</template>

<script>
import firebase from "firebase";
import mainMixin from "../../helpers/mixins/mainMixin";
import permissionMixin from "../../helpers/mixins/permissionMixin";
import tableActions from "@/components/TableActions";
import filterSelect from "@/components/FilterSelect";
//import keyWordGenerator from "@/helpers/mixins/keyWordGenerator.js";

export default {
  name: "Shops",
  components: {
    "filter-select": filterSelect,
    "table-actions": tableActions,
  },
  mixins: [mainMixin, permissionMixin /*keyWordGenerator*/],
  data() {
    return {
      field: null,
      order: null,
      queryString: "",
      companies: [],
      mainQuery: this.$db.collection("shops").where("isActive", "==", true),
      lastRequested: null,
      disableRequestMore: true,
      limit: 20,
      shopindex: 0,
      companiesindex: 0,
      companiesFilterInfo: {
        label: "company",
        options: [{ name: "*" }],
        filterValue: "*",
      },
      countriesFilterInfo: {
        label: "country",
        options: [{ name: "*" }],
        filterValue: "*",
      },
      companyFilter: undefined 
    };
  },
  mounted() {
    switch (this.userInfo.type) {
      case "A":
        this.permissions.canCreate = true;
        this.permissions.canEdit = true;
        this.permissions.canHide = true;
        this.permissions.canDelete = true;
        break;
      case "I":
        if (this.userInfo.level == "S") {
          this.permissions.canCreate = true;
          this.permissions.canEdit = true;
          this.permissions.canHide = true;
          this.permissions.canDelete = true;
        }
        break;
      case "C":
        break;
      default:
        this.$router.push("/forbidden");
        break;
    }
    if (this.$route.params.companyId) {
      this.setFilterValues(this.$store.state.filters.shops.country, this.$route.params.companyId)
    }
    this.loadData();
  },
  methods: {
    /*async saveAll() {
      await this.$db
        .collection("shops")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let newCom = doc.data();
            newCom.id = doc.id;
            newCom.searchArray = this.generateKeyWord([
              newCom.name,
              newCom.mercurio_id,
              newCom.address.city,
              this.companies.find(e => e.id == newCom.companyId).name
            ]);
            this.$db
              .collection("shops")
              .doc(doc.id)
              .update(newCom)
              .then(() => {
                console.log("aggiornato: " + doc.id);
              });
          });
        });
    },*/

    sortPressed(field, order) {
      this.field = field;
      this.order = order;
      this.searchData();
    },

    changesearchQuery(querystring = "") {
      this.queryString = querystring;
    },
    deleteItemModal(item, collection) {
      this.$buefy.dialog.confirm({
        title: this.$translate("attention"),
        message: this.$translate("delete_confirm_text"),
        cancelText: this.$translate("undo"),
        confirmText: this.$translate("delete"),
        onConfirm: () => {
          this.deleteItem(item, collection);
        },
      });
    },
    searchData() {
      this.tableOptions.loading = true;
      this.tableData = [];

      //update filter
      this.setFilterValues(this.countriesFilterInfo.filterValue, this.$store.state.filters.shops.company)

      this.mainQuery = this.$db.collection("shops");
      //if (this.$route.params.companyId) {
      if (this.companyFilter) {
        this.mainQuery = this.$db
          .collection("shops")
          //.where("companyId", "==", this.$route.params.companyId);
          .where("companyId", "==", this.companyFilter);
      } else if (this.$route.params.shopId) {
        this.mainQuery = this.$db
          .collection("shops")
          .where(
            firebase.firestore.FieldPath.documentId(),
            "==",
            this.$route.params.shopId
          );
      }

      this.mainQuery = this.mainQuery.where(
        "searchArray",
        "array-contains",
        this.queryString.toLowerCase()
      );
      if (this.countriesFilterInfo.filterValue != "*") {
        this.mainQuery = this.mainQuery.where(
          "address.country",
          "==",
          this.countriesFilterInfo.filterValue
        );
      }
      if (this.companiesFilterInfo.filterValue != "*") {
        let tempcompsearch = this.companies.find(
          (temp) => temp.name == this.companiesFilterInfo.filterValue
        );
        if (tempcompsearch != undefined) {
          this.mainQuery = this.mainQuery.where(
            "companyId",
            "==",
            tempcompsearch.id
          );
        }
      }
      if (!this.showHidden) {
        this.mainQuery = this.mainQuery.where("isActive", "==", true);
      }
      if (this.field != null) {
        this.mainQuery = this.mainQuery.orderBy(this.field, this.order);
      }
      this.lastRequested = null;
      this.shopindex = 0;
      this.companiesindex = 0;

      this.appendData();
    },
    loadFilterValues() {
      this.countriesFilterInfo.filterValue = this.$store.state.filters.shops.country
      this.companyFilter = this.$store.state.filters.shops.company
    },
    setFilterValues(country, company) {
      this.$store.commit('setFiltersShops', {
        country: country,
        company: company
      })
    },
    async loadData() {
      this.tableOptions.loading = true;
      await this.createFilters();
  
      this.loadFilterValues();    

      this.tableData = [];
      //if (this.$route.params.companyId) {
      if (this.companyFilter) {
        this.mainQuery = this.$db
          .collection("shops")
          //.where("companyId", "==", this.$route.params.companyId);
          .where("companyId", "==", this.companyFilter);
      } else if (this.$route.params.shopId) {
        this.mainQuery = this.$db
          .collection("shops")
          .where(
            firebase.firestore.FieldPath.documentId(),
            "==",
            this.$route.params.shopId
          );
      }
      if (this.countriesFilterInfo.filterValue != "*") {
        this.mainQuery = this.mainQuery.where(
          "address.country",
          "==",
          this.countriesFilterInfo.filterValue
        );
      }
      this.appendData();
    },
    appendData(newlimit = this.limit) {
      let thisQuery = this.mainQuery;
      if (this.lastRequested != null) {
        thisQuery = thisQuery.startAt(this.lastRequested);
      }
      if (!this.allCompanies) {
        if (this.allShops) {
          thisQuery = thisQuery.where(
            "companyId",
            "in",
            this.companiesId.slice(
              this.companiesindex,
              this.companiesindex + 10
            )
          );
        } else {
          thisQuery = thisQuery.where(
            firebase.firestore.FieldPath.documentId(),
            "in",
            this.shopsId.slice(this.shopindex, this.shopindex + 10)
          );
        }
      }
      thisQuery
        .limit(newlimit + 1)
        .get()
        .then((docs) => {
          if (docs.size > newlimit) {
            this.disableRequestMore = false;
          } else {
            this.disableRequestMore = true;
          }
          let i = 0;
          docs.forEach((doc) => {
            let newShop = doc.data();
            newShop.id = doc.id;
            newShop.company = {};
            let tempcat = this.companies.find(
              (temp) => temp.id == newShop.companyId
            );
            //console.log(tempcat);
            if (tempcat != undefined) {
              newShop.company = tempcat;
            }
            i++;
            if (i <= this.limit) {
              this.tableData.push(newShop);
            }
            this.lastRequested = doc;
          });
          if (
            this.disableRequestMore &&
            (this.shopsId.length > this.shopindex + 10 ||
              this.companiesId.length > this.companiesindex + 10)
          ) {
            this.shopindex += 10;
            this.companiesindex += 10;
            this.lastRequested = null;
            this.appendData(newlimit - docs.size);
          }
          this.tableOptions.loading = false;
        });
    },
    async createFilters() {
      this.companiesFilterInfo.options = [{ name: "*" }];
      this.countriesFilterInfo.options = [{ name: "*" }];
      await this.$db
        .collection("companies")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let comp = doc.data();
            comp.id = doc.id;
            this.companiesFilterInfo.options.push({
              name: comp.name,
            });
            this.companies.push(comp);
          });
        });
      await this.$db
        .collection("countries")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            this.countriesFilterInfo.options.push({
              name: doc.data().code,
            });
          });
        });
    },
  },
};
</script>

<style scoped>
.container >>> .table-footer td {
  color: #bdbdbd;
}

@media only screen and (min-width: 1280px) {
  .container >>> .b-table .table th {
    font-weight: 600;
    position: sticky;
    top: 120px;
    background: white;
    z-index: 8;
  }

  .first-level {
    height: 60px;
    background: white;
    top: 0px;
    position: sticky;
    z-index: 9;
    margin-top: 0;
    margin-bottom: 0;
  }

  .second-level {
    height: 60px;
    background: white;
    top: 60px;
    position: sticky;
    z-index: 8;
    margin-top: 0;
    margin-bottom: 0;
  }

  .container >>> .dropdown-menu {
    z-index: 5;
  }
}
</style>
